<script lang="ts">
    import { Word } from "../dictionary/Word";
import Panel from "../materialize/components/Panel.svelte";
    import { is_desktop_mediaquery } from "../settings";

    import {
        current_dialect,
        current_expanded_result_id,
        italian_language,
        languages,
    } from "../stores/stores";
    export let params = { pk_word: null };

    import {
        promise_or_go_offline,
        fetch_or_go_offline,
    } from "../utils/fetch_or_go_offline";
    import LoadingScreen from "./subcomponents/LoadingScreen.svelte";
    import SingleSearchResult from "./subcomponents/SingleSearchResult.svelte";
import WordSearchForm from "./subcomponents/WordSearchForm.svelte";
import WordSearchModalPopup from "./subcomponents/WordSearchModalPopup.svelte";

$: promise_fetch_word = retrieve_word(params.pk_word);

function retrieve_word(pk: number) {
    let p = fetch_or_go_offline(
        `/api/dictionary/word/${pk}`
    )
        .then((r) => {
            return r.json();
        })
        .then((r) => {
            let result_word: Word = new Word(r);
            if (result_word.language !== $italian_language.id) {
                $current_dialect = $languages.find(
                    (l) => l.id === result_word.language
                );
            }
            $current_expanded_result_id = result_word.id;
            return result_word;
        });
    return p;
}

    

    let is_desktop: boolean;
    let mediaquery = is_desktop_mediaquery;
    mediaquery.addEventListener("change", () => {
        is_desktop = !mediaquery.matches;
    });
    is_desktop = !mediaquery.matches;
</script>

{#if is_desktop}
    <Panel>
        <WordSearchForm></WordSearchForm>
    </Panel>
    {:else}
    <WordSearchModalPopup></WordSearchModalPopup>
{/if}
<h2>Risultati ricerca:</h2>
{#await promise_fetch_word}
    <LoadingScreen />
{:then result_word}
    <SingleSearchResult word={result_word} />
{:catch err}
    Errore nel caricare la parola
{/await}
